/**
 * Add listener to monitor unload event
 * @param {function} callback Function to execute before unload page
 */
function addUnloadListener(callback) {
    window.addEventListener("beforeunload", callback);

}

/**
 * Remove listener to monitor unload event
 * @param {function} callback Function to execute before unload page
 */
function removeUnloadListener(callback) {
    window.removeEventListener("beforeunload", callback);

}

/**
 * Prevent user close page
 */
function preventFromUnload(event) {
    event.preventDefault();
    event.returnValue = "";
}

export { addUnloadListener, removeUnloadListener, preventFromUnload};